import { ProductMessage } from '../../../../types/ProductMessage';
import { GetProductsByQueryParams } from '../../../common/api/clients/product.api';
import { queries } from '../../../common/api/queryKeys/queries';
import { usePaginationQuery } from '../../../common/hooks/usePaginationQuery';

export const useProductsPagination = (params: GetProductsByQueryParams) => {
    const nextPage = queries.products.pagination({ ...params, page: (params.page ?? 0) + 1 });

    return usePaginationQuery<ProductMessage>({
        ...queries.products.pagination(params),
        prefetchQueryKey: nextPage.queryKey,
        prefetchQueryFn: nextPage.queryFn,
    });
};
